import { useMainSectionsNav } from "@hooks/queries"
import { Link, useHydrating, useRoute } from "eddev/routing"
import { useSearch } from "@hooks/useSearch"
import { twMerge } from "tailwind-merge"

export const HomePagesNavigation = () => {
  return (
    <div className="hidden md:grid-auto">
      <div className="col-span-12 flex justify-center items-center">
        <HomesNav />
      </div>
    </div>
  )
}

export function HomesNav() {
  const route = env.admin ? null : useRoute()
  const navigationItems = useMainSectionsNav(undefined)
  const { open: searchOpen } = useSearch()
  const hydrating = useHydrating()

  return (
    <div
      className={twMerge(
        "items-center justify-center my-3 lg:my-0 lg:h-[100px]",
        searchOpen ? "hidden lg:flex" : "flex",
      )}
    >
      {!hydrating && navigationItems.data?.siteSettings?.themeSiteSettings?.mainSections && (
        <div className="flex gap-2 bg-searchBg p-2 lg:py-0 lg:h-[48px] items-center lg:gap-2 rounded-md w-full">
          {!env.admin &&
            navigationItems.data.siteSettings.themeSiteSettings.mainSections.map((section, i) => (
              <Link
                key={i}
                className={twMerge(
                  "button-nav",
                  route?.pathname.includes(section?.slug!) &&
                    (route?.pathname.replaceAll("/", "") === section?.slug ? "current" : "child"),
                )}
                href={section?.uri}
              >
                {section?.title}
              </Link>
            ))}
        </div>
      )}
    </div>
  )
}
